import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b235a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]

import { ref, type Ref } from 'vue';

type GithubInfo = {
  avatar_url: string,
  html_url: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GithubLink',
  props: {
    name: null
  },
  setup(__props: any) {

const props = __props as {
  name: string
};




const githubInfo: Ref<GithubInfo> = ref({avatar_url: '', html_url: ''})

fetch(`https://api.github.com/users/${props.name}`)
  .then((response) => response.json())
  .then((json: GithubInfo) => githubInfo.value = json);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "a github-link",
    href: githubInfo.value.html_url
  }, [
    _createElementVNode("img", {
      class: "github-link__avatar",
      src: `${githubInfo.value.avatar_url}&size=48`
    }, null, 8 /* PROPS */, _hoisted_2)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})